var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3155_30310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.00001 6.93333L14.9 6.93333C15.4667 6.93333 15.9333 7.4 15.9333 7.96666C15.9333 8.53333 15.4667 9 14.9 9H9.00001V14.9C9.00001 15.4667 8.53334 15.9333 7.96667 15.9333C7.40001 15.9333 6.93334 15.4667 6.93334 14.9L6.93334 9H1.03335C0.466679 9 0 8.53333 0 7.96666C0 7.4 0.466679 6.93333 1.03335 6.93333L6.93334 6.93333L6.93334 1.03333C6.93334 0.466664 7.40001 0 7.96667 0C8.53334 0 9.00001 0.466664 9.00001 1.03333V6.93333Z",
    fill: "#69BCC6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3155_30310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIPlus);
export default __webpack_public_path__ + "static/media/i-plus.288573507b6e6ce6194316a93060e73a.svg";
export { ForwardRef as ReactComponent };